export default __webpack_public_path__ + "static/media/team-lh.8944bd95.jpg";